// extracted by mini-css-extract-plugin
export default {"coverLink":"FJ-z","contentBox":"GJ-z","zapposPromoContainer":"HJ-z","zapposPromoGroupContainer":"IJ-z","promos":"JJ-z","bottom":"KJ-z","top":"LJ-z","right":"MJ-z","left":"NJ-z"};